// extracted by mini-css-extract-plugin
export default {"card":"Interest_card__EIZIL","card_main_div":"Interest_card_main_div__A9e5T","card_item":"Interest_card_item__utewO"};